//      
import React, { useState } from 'react';
import { includes } from 'lodash';
import { css } from 'styled-components';

import Button from './Button';
import Card from './Card';

             
                  
                       
  

              
                       
  

const accordionCss = css`
    .card {
        margin-bottom: 0;
        .card-body.collapse {
            display: none;
        }
        .card-body.collapse.show {
            display: block;
        }
    }
`;

export const Accordion = ({ items, className: _className, ...domProps }       ) => {
    const [expand, setExpand] = useState([]);

    const toggle = index => {
        if (includes(expand, index)) {
            setExpand(expand.filter(i => i !== index));
        } else {
            setExpand([...expand, index]);
        }
    };

    return (
        <div css={accordionCss} {...domProps}>
            {items.map(({ title, render }, index) => (
                <Card
                    key={index}
                    header={
                        <Button flavor='link' onClick={() => toggle(index)}>
                            {title}
                        </Button>
                    }
                    border='default'
                    bodyProps={{
                        className: `collapse ${includes(expand, index) ? 'show' : ''}`,
                    }}
                >
                    {render()}
                </Card>
            ))}
        </div>
    );
};

export default Accordion;
